import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ExhibitorsProjectType } from "../../types/ScientificModule";
import { get, post, put } from "../../utils/axios-config";
import { EXHIBITORS_PROJECTS } from "../../utils/constants";

export const createExhibitorsProject = async (data: ExhibitorsProjectType) => await post<ExhibitorsProjectType, string>(EXHIBITORS_PROJECTS, data);
export const updateExhibitorsProject = async (data: ExhibitorsProjectType) => await put<ExhibitorsProjectType, string>(EXHIBITORS_PROJECTS, data);

export const getExhibitorsProjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdExhibitor ? { IdExhibitor: data.IdExhibitor } : {}),
        ...(data?.IdProject ? { IdProject: data.IdProject } : {}),

    });
    const url = `${EXHIBITORS_PROJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ExhibitorsProjectType>>(url);
};
